export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["User"] = "USER";
    AccessLevel["Admin"] = "ADMIN";
})(AccessLevel || (AccessLevel = {}));
// Redux Types
export var UPDATE_SESSION = 'UPDATE_SESSION';
